<div class="mat-dialog-wrapper mat-dialog-wrapper-scroll">
  <div class="d-flex justify-space-between align-items-center mb-10">
    <h2 mat-dialog-title class="m-0">{{ headerText }}</h2>
    <div class="d-flex align-items-center gap-10">
      <button
        class="export-button"
        type="button"
        (click)="onDownloadClick()"
        mat-button
        disableRipple
        [disabled]="
          (isViewPermission$ | async) ||
          (!isJournalChangePermission && moduleId === modules.Journals) ||
          (!isRecieptChangePermission && moduleId === modules.Receipt) ||
          (!isPaymentChangePermission && moduleId === modules.Payment)
        "
      >
        <mat-icon class="text-primary" fontSet="material-icons-outlined"
          >save_alt</mat-icon
        >
      </button>
      <button
        *ngIf="this.moduleId !== modules.FixedAssetDetail && !data?.hideEditButton"
        class="edit-button"
        type="button"
        (click)="onEditClick()"
        mat-button
        disableRipple
        [disabled]="
          (!isJournalChangePermissionEdit && moduleId === modules.Journals) ||
          (!isRecieptChangePermissionEdit && moduleId === modules.Receipt) ||
          (!isPaymentChangePermissionEdit && moduleId === modules.Payment)
        "
      >
        <mat-icon class="text-primary" fontset="material-icons-outlined"
          >edit</mat-icon
        >
      </button>
      <button
          type="button"
          (click)="onCancel()"
          mat-button
          disableRipple
        >
          <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <mat-dialog-content>    
    <div
      *ngIf="isRender"
      [innerHTML]="moduleViewDetails | viewHtmlContent"
    ></div>
  </mat-dialog-content>
</div>

<app-custom-notifications></app-custom-notifications>
